import api from './api';

const reviewService = {
  async getProductReviews(productId, { page = 1, limit = 10 } = {}) {
    try {
      const response = await api.get(`/reviews/product/${productId}`, {
        params: { page, limit },
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch reviews',
      };
    }
  },

  async getMyReviews({ page = 1, limit = 10 } = {}) {
    try {
      const response = await api.get('/reviews/my', { params: { page, limit } });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch your reviews',
      };
    }
  },

  async getReviewableProducts(orderId) {
    try {
      const response = await api.get(`/reviews/order/${orderId}/reviewable`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to check reviewable products',
      };
    }
  },

  async createReview(reviewData) {
    try {
      const response = await api.post('/reviews', {
        productId: reviewData.productId,
        orderId: reviewData.orderId,
        rating: reviewData.rating,
        title: reviewData.title,
        comment: reviewData.comment,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to submit review',
      };
    }
  },

  async updateReview(reviewId, updates) {
    try {
      const response = await api.patch(`/reviews/${reviewId}`, updates);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update review',
      };
    }
  },

  async deleteReview(reviewId) {
    try {
      await api.delete(`/reviews/${reviewId}`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete review',
      };
    }
  },

  async adminGetAllReviews({ page = 1, limit = 20, approved } = {}) {
    try {
      const params = { page, limit };
      if (approved !== undefined) params.approved = approved;
      const response = await api.get('/reviews/admin/all', { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch reviews',
      };
    }
  },

  async adminToggleApproval(reviewId, approved) {
    try {
      const response = await api.patch(`/reviews/admin/${reviewId}/approve`, { approved });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update review visibility',
      };
    }
  },

  async adminDeleteReview(reviewId) {
    try {
      await api.delete(`/reviews/${reviewId}`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete review',
      };
    }
  },
};

export default reviewService;